import differenceBy from 'lodash/differenceBy';
import {
  RAFFLE_PAGE_DATA_REQUEST,
  RAFFLE_PAGE_DATA_SUCCESS,
  RAFFLE_PAGE_DATA_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RAFFLE_PAGE_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case RAFFLE_PAGE_DATA_SUCCESS: {

      const { tabType, selectedTickets, ticketsData } = action.payload;
      let updatedPayload = action.payload;

      if (tabType !== 'SPECIAL') {
        // Gelen bilet datası
        const tickets = ticketsData[tabType.toLowerCase()] && ticketsData[tabType.toLowerCase()].tickets || [];

        // Seçilen tab'a göre seçilmiş biletler ayrıştırılır. Sadece seçili tab'a özel seçilmiş biletler alınır.
        const sameSelectedTickets = selectedTickets.filter(ticketItem => ticketItem.ticketType === tabType && ticketItem.serialType === null);

        // Gelen datanın içerisinde daha önce seçilmişlerden varsa, onları siliyoruz.
        const removeSelecteds = differenceBy(tickets, sameSelectedTickets, 'ticketId');

        // Yukarıdaki silme işine istinaden gelen datadan çıkarılacak bilet sayısını hesaplıyoruz.
        const trimSize = sameSelectedTickets.length - (tickets.length - removeSelecteds.length);

        // Gelen datadan seçilen bilet kadar data atılır.
        const trimmedTickets = trimSize > 0 ? removeSelecteds.slice(0, -trimSize) : removeSelecteds;

        // Gelen datanın baş kısmına seçilen biletler eklenir.
        const updatedTickets = sameSelectedTickets.length > 0 ? [...sameSelectedTickets, ...trimmedTickets] : trimmedTickets;

        // Ek field'lar eklenir. Bu field'lar lottery slip için gereklidir.
        let enrichedTickets = updatedTickets.map(ticketItem => {
          return {
            ...ticketItem,
            ticketPrice: ticketsData[tabType.toLowerCase()].ticketPrice,
            ticketType: tabType,
            serialType: null
          };
        });

        // Güncellenmiş reducer datamızı oluşturuyoruz.
        updatedPayload = {
          ...action.payload,
          ticketsData: {
            ...action.payload.ticketsData,
            [tabType.toLowerCase()]: {
              ...action.payload.ticketsData[tabType.toLowerCase()],
              tickets: enrichedTickets
            }
          }
        };
      }

      return {
        data: {
          ...updatedPayload
        }, isLoading: false, error: null };
    }

    case RAFFLE_PAGE_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
